import { NavigateOptions, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectConfigSettings } from '../store/slices/config/configSelectors';
import { RentalType } from 'src/common/consts';

const usePlaceNavigate = (newTab = false) => {
  const navigate = useNavigate();
  const settings = useSelector(selectConfigSettings);
  const rentalType = settings?.rentalType as RentalType;
  const place = settings?.place as string;

  // Handles internal navigation adding the proper place name and rentaltype as a prefix to the desired path
  // This is required in order to easily navigate from any page to any other page without explicitly adding /fl-breward-city_of_margate-ltr-portal/otherpage
  // as a part of the navigation
  return (path: string | number, options?: NavigateOptions) => {
    if (newTab) {
      const internalUrl = getInternalUrl(place, rentalType, path as string);
      return window.open(
        internalUrl,
        '_blank',
        'toolbar=0,location=0,menubar=0'
      );
    }
    if (path !== '-1' && path !== -1) {
      return navigate(
        getInternalUrl(place, rentalType, path as string),
        options
      );
    }
    navigate(-1);
  };
};

export const useInternalUrl = (path = '') => {
  const settings = useSelector(selectConfigSettings);
  const rentalType = settings?.rentalType as RentalType;
  const place = settings?.place as string;
  return getInternalUrl(place, rentalType, path);
};

export const getInternalUrl = (
  place: string,
  rentalType: RentalType,
  path: string
) => `/${place}-${rentalType}-portal${path}`;

export default usePlaceNavigate;
